module.exports = __webpack_public_path__ + "static/media/balance-scale-right.414e66c9.svg";